(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-slideshow"] && !window.DesignMode) return;
  try {
    

$('.dot-menu-dot').click(function () {
        var slideNumber = $(this).data('slide-to');
        $('.dot-menu-dot').removeClass('active');
        $(this).addClass('active');
        console.log(slideNumber);
        $('.justins-slide').css('opacity', 0);
        $('.justins-slide').hide();
        $('.justins-slide[data-slide="' + slideNumber + '"]').show();
        $('.justins-slide[data-slide="' + slideNumber + '"]').css('opacity', 1);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

var slideIndex = 1;   
showDivs(slideIndex);

function plusDivs(n) {
  showDivs(slideIndex += n);
}

$('.dot-menu-dot').click(function () {
        var slideNumber = $(this).data('slide-to');
        $('.dot-menu-dot').removeClass('active');
        $(this).addClass('active');
        console.log(slideNumber);
        $('.justins-slide').css('opacity', 0);
        $('.justins-slide').hide();
        $('.justins-slide[data-slide="' + slideNumber + '"]').show();
        $('.justins-slide[data-slide="' + slideNumber + '"]').css('opacity', 1);
});

function showDivs(n) {
  var i;
  var x = document.getElementsByClassName("justins-slide");
  if (n > x.length) {slideIndex = 1}
  if (n < 1) {slideIndex = x.length}
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
    x[slideIndex-1].style.opacity = 1;
    for(var j = 0; j <= 100; j++){
      x[slideIndex-1].style.opacity = (j / 100) ;
    }
  }
  $('#justins-slider-menu>span').removeClass("active");
  $('#slide-'+(slideIndex-1)).addClass( "active" );
  x[slideIndex-1].style.display = "block";
  x[slideIndex-1].style.opacity = 1;

};                      
 
var oldX = 0;
 
function getMouseDirection(e) {

    if (oldX < e.pageX) {
      plusDivs(-1);
      bodyElement.removeEventListener("mousemove", getMouseDirection, false);
    } else {
      plusDivs(1);
      bodyElement.removeEventListener("mousemove", getMouseDirection, false);
    }
 
    oldX = e.pageX;
}
      
bodyElement.addEventListener("touchstart", handleStart, false);                     

function handleStart(evt) {
  bodyElement.addEventListener('touchmove', handleMove, false);  
}
                                                        
function handleMove(evt) {
  evt.preventDefault();
  var touches = evt.changedTouches;

  if (oldX < touches[0].screenX) {
      plusDivs(-1);
      bodyElement.removeEventListener('touchmove', handleMove, false);
    } else {
      plusDivs(1);
      bodyElement.removeEventListener('touchmove', handleMove, false);
    }
  oldX = touches[0].screenX;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-updated"]) return;
  try {
    

var slideIndex = 1;   
showDivs(slideIndex);

function plusDivs(n) {
  showDivs(slideIndex += n);
}

$('.dot-menu-dot').click(function () {
        var slideNumber = $(this).data('slide-to');
        $('.dot-menu-dot').removeClass('active');
        $(this).addClass('active');
        console.log(slideNumber);
        $('.justins-slide').css('opacity', 0);
        $('.justins-slide').hide();
        $('.justins-slide[data-slide="' + slideNumber + '"]').show();
        $('.justins-slide[data-slide="' + slideNumber + '"]').css('opacity', 1);
});

function showDivs(n) {
  var i;
  var x = document.getElementsByClassName("justins-slide");
  if (n > x.length) {slideIndex = 1}
  if (n < 1) {slideIndex = x.length}
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
    x[slideIndex-1].style.opacity = 1;
    for(var j = 0; j <= 100; j++){
      x[slideIndex-1].style.opacity = (j / 100) ;
    }
  }
  $('#justins-slider-menu>span').removeClass("active");
  $('#slide-'+(slideIndex-1)).addClass( "active" );
  x[slideIndex-1].style.display = "block";
  x[slideIndex-1].style.opacity = 1;

};                      
 
var oldX = 0;
 
function getMouseDirection(e) {

    if (oldX < e.pageX) {
      plusDivs(-1);
      bodyElement.removeEventListener("mousemove", getMouseDirection, false);
    } else {
      plusDivs(1);
      bodyElement.removeEventListener("mousemove", getMouseDirection, false);
    }
 
    oldX = e.pageX;
}
      
bodyElement.addEventListener("touchstart", handleStart, false);                     

function handleStart(evt) {
  bodyElement.addEventListener('touchmove', handleMove, false);  
}
                                                        
function handleMove(evt) {
  evt.preventDefault();
  var touches = evt.changedTouches;

  if (oldX < touches[0].screenX) {
      plusDivs(-1);
      bodyElement.removeEventListener('touchmove', handleMove, false);
    } else {
      plusDivs(1);
      bodyElement.removeEventListener('touchmove', handleMove, false);
    }
  oldX = touches[0].screenX;
}


  } catch(e) { console.error(e); }
})();

})();
